import React from "react";
import styled, { keyframes } from "styled-components";
import { buildColor } from "@tvg/design-system";

const pulseAnimation = keyframes`
  0% {
   opacity: 1
  }

  50% {
    opacity: 0.5
  }

  100% {
    opacity: 1
  }
`;

const Container = styled.div`
  display: flex;
  height: 58px;
  background-color: ${buildColor("white", "900")};
  align-items: center;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
`;

const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "900")};
`;

const Box = styled.div`
  display: flex;
  height: 58px;
  width: 94px;
  background-color: ${buildColor("grey", "000")};
  animation: ${pulseAnimation} 1.25s infinite;
  margin-right: 12px;
  border-right: 1px solid ${buildColor("blue", "100")};
  border-top-left-radius: 4px;
`;

const SVG = styled.svg<{ isMobile: boolean }>`
  animation: ${pulseAnimation} 1.25s infinite;
  margin-right: ${({ isMobile }) => (isMobile ? "0" : "24px")};
`;

interface BetSelectorLoadingProps {
  isMobile: boolean;
}

const DesktopLoading = () => (
  <Container>
    <Box />
    {[...Array(4).keys()].map((_, index) => (
      <SVG
        key={index.toString()}
        xmlns="http://www.w3.org/2000/svg"
        width="67"
        height="12"
        viewBox="0 0 67 12"
        fill="none"
        isMobile={false}
      >
        <rect width="67" height="12" rx="1" fill="#E9EFF5" />
      </SVG>
    ))}
  </Container>
);

const MobileLoading = () => (
  <MobileContainer>
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="48"
      viewBox="0 0 375 48"
      fill="none"
      preserveAspectRatio="none"
      isMobile
    >
      <g clipPath="url(#clip0_4313_332794)">
        <g filter="url(#filter0_i_4313_332794)">
          <rect width="375" height="48" fill="white" />
          <rect x="12" y="18" width="67" height="12" rx="1" fill="#E9EFF5" />
          <rect x="103" y="18" width="67" height="12" rx="1" fill="#E9EFF5" />
          <rect x="194" y="18" width="67" height="12" rx="1" fill="#E9EFF5" />
          <rect x="285" y="18" width="67" height="12" rx="1" fill="#E9EFF5" />
        </g>
        <path d="M375 0H331V47H375V0Z" fill="url(#paint0_linear_4313_332794)" />
      </g>
      <defs>
        <filter
          id="filter0_i_4313_332794"
          x="0"
          y="0"
          width="375"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_4313_332794"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4313_332794"
          x1="375"
          y1="23.5"
          x2="331"
          y2="23.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_4313_332794">
          <rect width="375" height="48" fill="white" />
        </clipPath>
      </defs>
    </SVG>
  </MobileContainer>
);

const BetSelectorLoading = ({ isMobile }: BetSelectorLoadingProps) =>
  isMobile ? <MobileLoading /> : <DesktopLoading />;

export default BetSelectorLoading;
